import Modal from 'react-bootstrap/Modal';
import { IoClose } from 'react-icons/io5';
import modalStyles from '../../css/style.module.css';
import downloadStyles from './TimesheetDownloadModal.module.css';

const TimesheetCompleteModal = ({
  show,
  onHide,
  onConfirm,
  completing,
  staffName,
  customerName,
  scheduledEnd,
  completeUntil,
}) => {
  return (
    <Modal show={show} onHide={onHide} size="sl" centered>
      <Modal.Body>
        <div className={modalStyles.modaldownload}>
          <div className={modalStyles.modaldownloadheading}>
            <h6>{completing ? 'Marking Job Complete' : 'Confirm Job Completion'}</h6>
            {!completing && <IoClose color="#000000" size={25} onClick={onHide} />}
          </div>

          <div className={downloadStyles.summaryBox}>
            {completing ? (
              <p className={downloadStyles.message}>
                Marking job as completed for <strong>{staffName || 'this employee'}</strong>...
              </p>
            ) : (
              <>
                <p className={downloadStyles.message}>
                  Are you sure you want to mark this staff shift as completed? This can only be done
                  after the scheduled end time and within 24 hours of it.
                </p>
                {staffName && (
                  <div className={downloadStyles.detailRow}>
                    <span>Employee</span>
                    <strong>{staffName}</strong>
                  </div>
                )}
                {customerName && (
                  <div className={downloadStyles.detailRow}>
                    <span>Customer</span>
                    <strong>{customerName}</strong>
                  </div>
                )}
                {scheduledEnd && (
                  <div className={downloadStyles.detailRow}>
                    <span>Scheduled end</span>
                    <strong>{scheduledEnd}</strong>
                  </div>
                )}
                {completeUntil && (
                  <div className={downloadStyles.detailRow}>
                    <span>Complete until</span>
                    <strong>{completeUntil}</strong>
                  </div>
                )}
              </>
            )}
          </div>

          {!completing && (
            <div className={modalStyles.modaldownloadbutton} style={{ display: 'flex', gap: '12px' }}>
              <button type="button" onClick={onHide} style={{ background: '#5A5A5A' }}>
                Cancel
              </button>
              <button type="button" onClick={onConfirm} style={{ background: '#00AD1D' }}>
                Confirm Complete
              </button>
            </div>
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default TimesheetCompleteModal;
